import styled from 'styled-components';
import theme from 'styled-theming';

export const formBorderColor = theme('name', {
  light: '#e0e0e0',
  dark: '#444444',
});

export const FormProviderWrapper = styled.div`
  .invalid {
    border: 1px solid rgba(217, 54, 56, 0.8);
    box-shadow: 0 0 0 2px rgba(217, 54, 56, 0.2);
    transition: all 0.2s ease;
  }

  .already-exists {
    color: rgba(217, 54, 56, 1);
    font-style: italic;
    text-align: center;
    font-size: 15px;
    font-weight: 500;
    margin-top: 16px;
    padding: 12px;
    background-color: rgba(217, 54, 56, 0.05);
    border-radius: 6px;
    border-left: 4px solid rgba(217, 54, 56, 0.8);
  }

  .shell-date-picker-time-panel-column:last-child {
    display: none;
  }

  .formula {
    font-size: 12px;
    font-weight: 500;
  }

  .loading-message {
    text-align: center;
    padding: 30px 20px;
    font-size: 16px;
    color: #555;
    font-weight: 500;
  }

  .ant-form-item-label > label {
    font-weight: 500;
  }

  .ant-input,
  .ant-select-selector,
  .ant-picker {
    border-radius: 6px;
    transition: all 0.3s ease;

    &:hover {
      border-color: #1890ff;
    }

    &:focus {
      box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
    }
  }

  .ant-form-item {
    margin-bottom: 18px;
  }

  textarea {
    min-height: 80px;
    resize: vertical;
  }
`;

export const FormWrapper = styled.div`
  padding: 5px;
`;

export const FormSection = styled.div`
  margin-bottom: 5px;
  padding-bottom: 5px;
  border-bottom: 1px solid ${formBorderColor};

  &:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }

  h3 {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 16px;
  }
`;
